export default __webpack_public_path__ + "static/media/popup-diagonal-left.da9b403e.svg";